import React from 'react';
import { motion } from 'framer-motion';
export function UrgencySection() {
  return <motion.section initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.8
  }} className="my-16 space-y-8" data-id="element-216">
      <h3 className="text-2xl md:text-3xl font-bold text-[#1B2A4A] text-center" data-id="element-217">
        The Clock Is Running
      </h3>

      <div className="space-y-6 text-lg md:text-xl text-[#1B2A4A] text-center" data-id="element-218">
        <p data-id="element-219">
          Every month you wait to act, you lose another month of higher payments
          you&apos;ll never get back.
        </p>

        <p className="font-medium" data-id="element-220">
          If your corrected benefit would be $575 more per month, that&apos;s:
        </p>

        <div className="space-y-4 py-4" data-id="element-221">
          <p className="text-lg md:text-2xl font-bold text-[#1B2A4A]" data-id="element-222">
            <span className="text-[#D4652A] block text-xl md:text-2xl md:inline" data-id="element-223">
              $575
            </span>{' '}
            <span className="text-base md:text-2xl" data-id="element-224">lost after 1 month</span>
          </p>
          <p className="text-xl md:text-3xl font-bold text-[#1B2A4A]" data-id="element-225">
            <span className="text-[#D4652A] block text-2xl md:text-3xl md:inline" data-id="element-226">
              $3,450
            </span>{' '}
            <span className="text-base md:text-3xl" data-id="element-227">lost after 6 months</span>
          </p>
          <p className="text-2xl md:text-4xl font-bold text-[#1B2A4A]" data-id="element-228">
            <span className="text-[#D4652A] block text-3xl md:text-4xl md:inline" data-id="element-229">
              $6,900
            </span>{' '}
            <span className="text-lg md:text-4xl" data-id="element-230">lost after 1 year</span>
          </p>
        </div>

        <p className="italic text-[#1B2A4A]/80" data-id="element-231">
          This isn&apos;t a scare tactic. It&apos;s just math. The same math the
          SSA uses.
        </p>

        <p className="font-medium border-t border-[#1B2A4A]/10 pt-6 mt-6" data-id="element-232">
          The guide takes 15 minutes to read. The phone call to SSA takes 20
          minutes. You could have this handled by tomorrow morning.
        </p>
      </div>
    </motion.section>;
}